import request from '@/util/server.js'
// 首页模块

// 供需分页查询
export function getList (params) {
  return request({
    url: '/supply/demand/list',
    method: 'post',
    data: params
  })
}

// 采购数据-最新报价列表
export function getBidList (params) {
  return request({
    url: '/supply/demand/bidList',
    method: 'post',
    data: params
  })
}

// 采购大厅首页-采购详情
export function getInfo (params) {
  return request({
    url: '/supply/demand/info',
    method: 'get',
    params
  })
}

// 采购大厅首页-热门采购
export function getHotList (params) {
  return request({
    url: '/supply/demand/hot/list',
    method: 'post',
    data: params
  })
}

//  采购数据（询价/报价数量）
export function getCount (params) {
  return request({
    url: '/supply/demand/count',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/home/procure.js